import { LayoutBlock } from "./LayoutBlock";

export class LayoutRow {
    public Id: string;
    public Hidden: boolean = false;
    public Blocks: LayoutBlock[];
}

